import { createNetworkLogo } from 'src/modules/utils/plans'
import { networkLogos } from '../networkLogos'

export const COMMON_FEATURES = {
  CLOUD_DVR: 'Unlimited Cloud DVR included',
  MULTI_SCREEN: 'Watch on up to 10 screens at once',
  NFL_GAMES: 'Access to NFL games',
}

export const PlanIntervals = {
  monthly: 'monthly',
  quarterly: 'quarterly',
  annual: 'annual',
}

export const RSNS_BY_SPORT_TYPE = {
  nba: [
    createNetworkLogo(networkLogos.abc, 30, 30),
    createNetworkLogo(networkLogos.fox, 60, 24),
    createNetworkLogo(networkLogos.cbs, 50, 20),
    // createNetworkLogo(networkLogos.nbc, 65, 30),
    // TEMPORARY NBC DISPUTE
    createNetworkLogo(networkLogos.espn, 48, 20),
    {
      alt: '+ More',
    },
  ],
}
